// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"20359781","514":"a5d4cce3"}[chunkId] + ".chunk.js";
};